// Which work centres a picker may offer (spec 16 §2.4; the production pickers'
// rule, now one rule for every area).
//
// An archived work centre is one nobody may be sent to, so offering it in a
// picker is a control that exists to be refused. The demo tenant's Extrusion
// plant carries about 3,900 archived run stations from the walkthroughs, and
// the floor's station picker and the planning calendars listed every one of
// them above the real machines.
//
// A screen that LABELS existing rows still reads every status, because a work
// order, an assignment or a scoreboard row made before a station was archived
// must keep its name. Such a screen reads the whole list once and hands its
// pickers `pickableWorkCenters(list)`. A screen that only picks asks the
// endpoint for `status: "active"` instead. `__tests__/work-center-picker-census.test.ts`
// holds every caller of the list hooks to one of the two.

/** The active rows of a work-centre list, in the order given. */
export function pickableWorkCenters<T extends { readonly status: string }>(
  items: readonly T[] | undefined,
): T[] {
  return (items ?? []).filter((wc) => wc.status === "active");
}
